import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ReadSpendRuleDto } from '../../program';
import { ReadPreparedSpendRuleErrorDto } from './ReadPreparedSpendRuleErrorDto';
export class ReadStoreLoyaltyRewardDto {
}
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    Type(() => ReadPreparedSpendRuleErrorDto),
    ApiProperty({ type: () => ReadPreparedSpendRuleErrorDto, isArray: true }),
    __metadata("design:type", Array)
], ReadStoreLoyaltyRewardDto.prototype, "errors", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ type: () => Boolean }),
    __metadata("design:type", Boolean)
], ReadStoreLoyaltyRewardDto.prototype, "isApplied", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ type: () => Boolean }),
    __metadata("design:type", Boolean)
], ReadStoreLoyaltyRewardDto.prototype, "isApplicable", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ type: () => Number, example: 1 }),
    __metadata("design:type", Number)
], ReadStoreLoyaltyRewardDto.prototype, "availableApplicationCount", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    Type(() => ReadSpendRuleDto),
    ApiProperty({ type: () => ReadSpendRuleDto }),
    __metadata("design:type", ReadSpendRuleDto)
], ReadStoreLoyaltyRewardDto.prototype, "rule", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], ReadStoreLoyaltyRewardDto.prototype, "merchantId", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ type: () => String, isArray: true }),
    __metadata("design:type", Array)
], ReadStoreLoyaltyRewardDto.prototype, "locations", void 0);
//# sourceMappingURL=ReadStoreLoyaltyRewardDto.js.map